// extracted by mini-css-extract-plugin
export default {"login":"LoginScreen_login__yDdEG","google":"LoginScreen_google__j6j1+","signup":"LoginScreen_signup__3VkNm","signup-link":"LoginScreen_signup-link__VtPXS"};